import React, {useState} from "react";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {FaGithub, FaGlobe, FaLink, FaLinkedin} from "react-icons/fa";
import {FaLinkSlash} from "react-icons/fa6";
import INFO from "../../core/data/basic";

function FooterComponent (){

    const { t, i18n } = useTranslation()

    const _dateYear = new Date().getFullYear();

    const _build = new Date().toLocaleDateString('UK').split('.');

    const _versionWebsite = [
        "v1", "v2", "v3", "v4", "v4.2.1", "v5"
    ];

    const handleClick = (e) => {
        alert('You will be redirect to old version this website')
        window.location.href = 'https://' + _versionWebsite[e.target.value] + '.lukyanchuk.com'
    }

    const _qrLinkImages = [
        {
            name: "telegram",
            qr: "/assets/img/qr/tg.png",
        },
        {
            name: "signal",
            qr: "/assets/img/qr/signal.png",
        },
        {
            name: "whatsapp",
            qr: "/assets/img/qr/whatsapp.png",
        },
    ];

    //TODO: generate QR code use url
    const _contacts = [
        {
            title: "Phone",
            username: INFO.phoneLifecell,
            url: "tel.:" + INFO.phoneLifecell
        },
        {
            title: "E-Mail",
            username: INFO.email,
            url: "mailto:" + INFO.email
        },
        {
            title: "LinkedIn",
            username: 'a028481ab',
            url: INFO.socialLinkedIn
        },
    ]

    const [activeQr, setActiveQr] = useState('telegram')

    //TODO: rebuild qr img to generate qr code

    return (<footer className={'footer'}>

        <div className="p-md-5 p-4 border rounded-5 shadow-lg bg-dark">

            <div className="row">
                <div className="col-md-6 col-12 text-md-start text-center d-md-block-d-none">
                    <h2 className={'text-white display-1'}>
                        {/*Y. L.*/}
                        {t('my.name')}
                    </h2>
                    {/*<small className={'text-secondary lead'}>*/}
                    {/*    {t('my.job')}*/}
                    {/*</small>*/}

                    <p className={'mt-5'}>
                        <a href={'mailto:' + INFO.emailTuta} target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                            <>
                                {INFO.emailTuta}
                            </>
                        </a>
                    </p>

                    <p>
                        <a href={'tel.:' + INFO.phoneLifecell} target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                            <>
                                {INFO.phoneLifecell}
                            </>
                        </a>
                    </p>

                    <p className={'d-none1'}>
                        <Link to={'https://linkedin.com/'} target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                           <small><FaLinkedin /> LinkedIn </small>
                        </Link>
                        <Link to={'https://github.com/yarikthe'} target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                            <small><FaGithub /> GitHub </small>
                        </Link>
                        <Link to={'/links'} target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                            <small>
                                {/*<FaLink />*/}
                                <svg className="w-6 h-6 text-gray-800 dark:text-white m-1" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                     fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                                </svg>
                                y-l.pro/links
                            </small>
                        </Link>
                    </p>

                </div>

                <div className="col-md-6 col-12 text-md-end text-center">
                    <div className="qr-scan-contact__footer">
                        {
                            _qrLinkImages.filter((a) => a.name === activeQr).map((item, i) =>

                                <Zoom><img id={'qr_footer'} src={item.qr} alt="qr" className={'img-fluid'}/> </Zoom>
                            )
                        }
                        <br/>
                        <div className="d-inline-flex justify-between align-items-center">
                            <small className={activeQr === 'telegram' ? 'text-white p-1' : 'text-secondary p-1'} onClick={()=>setActiveQr('telegram')}>
                                telegram
                            </small>
                            <small className={activeQr === 'signal' ? 'text-white p-1' : 'text-secondary p-1'} onClick={()=>setActiveQr('signal')}>
                                signal
                            </small>
                            <small className={activeQr === 'whatsapp' ? 'text-white p-1' : 'text-secondary p-1'} onClick={()=>setActiveQr('whatsapp')}>
                                whatsapp
                            </small>
                            <small className="text-secondary p-1 pb-2">
                                ...
                            </small>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div className="p-md-5 pt-md-0 pb-md-0 p-2 d-flex justify-content-between align-items-center">

            <div className="copyright">
                {/*<Link to="/info#privacy-policy" className={'text-decoration-none text-secondary nav-link'}>*/}
                {/*    <small className={'lead-opacity-25'}>*/}
                {/*        {t('p-p')}*/}
                {/*    </small>*/}
                {/*</Link>*/}

                <p className={'mt-3'}>
                   <small className="text-muted">
                       {t('nav.copyright')} © {_dateYear}. {t('my.name')}.
                   </small>
                </p>
            </div>
            <form action="https://www.paypal.com/donate" method="post" target="_top" className={'d-none'}>
                <input type="hidden" name="hosted_button_id" value="V9YGTAHG9S94Q" />
                <input type="image" src="https://pics.paypal.com/00/s/YmIyOGMzMGEtN2QzNS00YmY3LWI3MjMtZGZlOWYxZDQ1ZDhl/file.PNG" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                <img alt="" border="0" src="https://www.paypal.com/en_UA/i/scr/pixel.gif" width="1" height="1" />
            </form>
            <div className="version-build">
                <select name="" id="version-website"
                        style={{
                            appearance: 'none',
                            webkitAppearance: 'none',
                            mozAppearance: 'none',
                            fontSize: '12px',
                            padding: '20px'
                        }}
                        onChange={handleClick}
                        className={'bg-transparent text-secondary border border-secondary rounded-pill p-1 text-center opacity-50'}>
                    {
                        _versionWebsite.map((version, i) => <option
                            value={i}
                            selected={i === _versionWebsite.length-1}
                            className={'m-2'}
                        >
                            <small className={'text-secondary'}>{version + '.0'}</small>
                        </option>)
                    }
                </select>
                <small className="text-muted p-1">
                    {/*🔒 */}
                    🧑‍💻 {_build[0]+_build[1]+'26'}
                </small>
            </div>

        </div>

    </footer>);
}

export default FooterComponent;
